import styles from './errorModal.module.scss';
import Image from 'next/image';

interface SuccessModalProps {
  onClose?: () => void;
}

const ErrorModal: React.FC<SuccessModalProps> = ({ onClose }) => {
  const handleContentClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={handleContentClick}>
        <button className={styles.closeButton} onClick={onClose}>
          <Image
            src="/img/modal/close.svg"
            alt="Close"
            width={24}
            height={24}
          />
        </button>
        <div className={styles.logoContainer}>
          <Image
            src="/img/modal/error-logo.webp"
            alt="Hera Flight"
            width={136}
            height={108}
          />
        </div>
        <h2 className={styles.title}>Oops, something went wrong</h2>
        <p className={styles.message}>
          Please check your connection and try again. <br /> Or contact us using
          the methods below.
        </p>

        <div className={styles.errorBottom}>
          <div className={styles.errorBottomItem}>
            <p className={styles.errorBottomItemTitle}> Phone</p>
            <a href="tel:18335394372" className={styles.phoneLink}>
              <div className={styles.errorBottomItemText}>1-833-FLY-HERA</div>
            </a>
          </div>
          <div className={styles.errorBottomItem}>
            <p className={styles.errorBottomItemTitle}>Charter Quotes</p>
            <a
              href="mailto:charter@heraflight.com"
              className={styles.phoneLink}
            >
              <div className={styles.errorBottomItemText}>
                charter@heraflight.com
              </div>
            </a>
          </div>
          <div className={styles.errorBottomItem}>
            <p className={styles.errorBottomItemTitle}>
              Inquiries, Sales & Quotes
            </p>
            <a href="mailto:sales@heraflight.com" className={styles.phoneLink}>
              <div className={styles.errorBottomItemText}>
                sales@heraflight.com
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
